/* grillion-about.js - GRILLION About Page Interactions */

document.addEventListener('DOMContentLoaded', () => {
  initAboutInteractions();
});

function initAboutInteractions() {
  // Optional interaction handlers for About page components
}
